<template>
  <b-modal ref="addItemModal"
           id="modal-add-issue"
           title="Добавить выпуск"
           hide-footer>
      <b-form @submit="onSubmit" @reset="onReset" class="w-100">
      <alertMsg :message="alertMessage" v-if="showAlert"></alertMsg>
      <b-form-group id="form-title-group-name" label="Наменование">
        <b-form-input id="name"
                        type="text"
                        placeholder="Введите название выпуска"
                        v-model="addForm.name"
                        required>

        </b-form-input>
      </b-form-group>
      <b-form-group id="form-title-group-link" label="Ссылка">
        <b-form-input id="link"
                        type="tel"
                        placeholder="Введите ссылку"
                        v-model="addForm.link"
                        required>

        </b-form-input>
      </b-form-group>
      <b-form-group id="form-title-group-mass_media" label="Газета/журнал">
        <b-form-select id="group"
                        type="text"
                        placeholder="Газета/журнал"
                        v-model="addForm.mass_media"
                        :options="groups"
                        required>

        </b-form-select>
      </b-form-group>
      <b-form-group id="form-title-vipusk-pic" label="Изображение"> 
        <picture-input ref="pictureInput" width="200" height="200" margin="8" accept="image/jpeg,image/png" size="10"
          :removable="true" :customStrings="{
          upload: '<h1>Перетащите изображение</h1>',
          drag: 'Перетащите изображение',
          change: 'Заменить фото',
          remove: 'Удалить фото',
        }">
        </picture-input>
      </b-form-group>
      <b-button type="submit" variant="success">Добавить</b-button>
      <b-button type="reset" variant="">Отмена</b-button>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
import alertMsg from '../common/AlertMsg';
import PictureInput from 'vue-picture-input';

export default {
  components: {
    alertMsg,
    PictureInput
  },
  name: 'modalAdd',
  data() {
    return {
      addForm: {
        name: '',
        link: '',
        mass_media: '',
        image: '',
      },
      alertMessage: 'Error',
      showAlert: false,
      groups: [],
    };
  },
  computed: {
    ...mapState({
      host: state => state.host,
    }),
    isAuthorised() {
      return this.$store.getters.isAuthorised;
    },
  },
  methods: {
    ...mapActions([
      'alertMsg', // -> this.alertMsg()
    ]),
    addItem(payload) {
      this.showAlert = false;
      const id = 'modal-add-issue';
      const path = this.host + 'add_issue';
      axios.post(path, payload, { headers: { 'Content-Type': 'application/json' } })
        .then((res) => {
          if (res.data.status === 'success') {
            this.$bvModal.hide(id);
            this.$emit('issue');
            this.alertMsg({
              alert: res.data.message,
              type: 'success',
            });
            this.initForm();
          } else {
            this.alertMessage = `${res.data.status}: ${res.data.error}`;
            this.showAlert = true;
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
        });
    },
    take_groups() {
      this.showAlert = false;
      const path = this.host + 'take_medias';
      axios.post(path, {}, { headers: { Authorization: `Bearer ${localStorage.token}` } })
        .then((res) => {
          if (res.data.status === 'success') {
            this.groups = res.data.medias;
          } else {
            this.alertMessage = `${res.data.status}: ${res.data.error}`;
            this.showAlert = true;
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
        });
    },
    onSubmit(evt) {
      evt.preventDefault();
      let payload = {
        'name' : this.addForm.name,
        'link' : this.addForm.link,
        'mass_media' : this.addForm.mass_media,
        'image' : this.$refs.pictureInput.image,
        'image_name' : this.$refs.pictureInput.file.name
      };
      this.addItem(payload);
    },
    onReset(evt) {
      evt.preventDefault();
      this.$bvModal.hide('modal-add-issue');
      this.initForm();
    },
    initForm() {
      this.addForm.name = '';
      this.addForm.link = '';
      this.addForm.mass_media = '';
      this.addForm.image = '';
    },
  },
  created() {
    this.take_groups();
  },
};
</script>

<style scoped>

</style>
